<template>
  <span class="ml-2">
    <v-progress-circular indeterminate color="primary" v-if="deleting"></v-progress-circular>
    <v-icon @click="deleteRegister" size="30" v-else color="grey">
      mdi-trash-can-outline
    </v-icon>
  </span>
</template>
<script>
export default {
  props: {
    register: {
      required: true,
      type: Object,
    },
  },
  data: () => ({ deleting: false }),
  methods: {
    deleteRegister() {
      window.Notify.confirm(
        'This action will delete the register from the central server & from the client instance as well, assuming it exists',
        'Delete register?',
      ).then(() => {
        this.deleting = true;
        this.$http
          .delete(`api/v1/registers/${this.register.global_id}`)
          .then(() => {
            this.deleting = false;
            this.$emit('delete:register', this.register);
            window.Notify.success('Register was deleted successfully');
          })
          .catch(error => {
            this.deleting = false;
            this.showResponseError(error);
          });
      });
    },
  },
};
</script>
